/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdatePoolCoinAddressRequest } from './update-pool-coin-address-request';


export interface UpdatePoolRequest { 
    id: string;
    name: string;
    coinAddresses?: Array<UpdatePoolCoinAddressRequest> | null;
}

